export default __webpack_public_path__ + "static/media/Darkmode.c6a37495.gif";